import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export default function SectionHeading({ eyebrow, title, sub, align = "left", testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
      className={cn(align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl")}
      data-testid={testId}
    >
      {eyebrow && (
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.24em] text-brand-blue">
          {eyebrow}
        </p>
      )}
      <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
        {title}
      </h2>
      {sub && <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg">{sub}</p>}
    </motion.div>
  );
}
